export const DP_316_TEST_NAME = 'new_pro_badge_dp316_test_20231018';
export const DP_316_TEST_PERCENT = 0.5;
export const NEW_PRO_DAYS = 60;
export const NEW_PRO_MIN_REVIEWS = 1;
